
export default {
	props: {
		color: String,
		text: String,
		size: {
			type: String,
		},
		disabled: Boolean,
		loading: Boolean,
	},

	computed: {
		isDisabled() {
			return this.disabled || this.loading
		},
	},
}
